import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg, useTitle } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  useTitle("Şifre Sıfırlama");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== password2) return toast.error("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.");
      navigate("/giris");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14">
      <div className="card p-8">
        <h1 className="text-xl font-extrabold text-white mb-2">Yeni Şifre Belirle</h1>
        <p className="text-sm text-slate-400 mb-6">Hesabınız için yeni bir şifre belirleyin.</p>
        {!token ? (
          <p className="text-sm text-red-400">Geçersiz bağlantı. Lütfen e-postanızdaki bağlantıyı kullanın.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">Yeni Şifre</label>
              <input data-testid="reset-password" type="password" className="input" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div>
              <label className="label">Yeni Şifre (Tekrar)</label>
              <input data-testid="reset-password-confirm" type="password" className="input" required minLength={6} value={password2} onChange={(e) => setPassword2(e.target.value)} />
            </div>
            <button data-testid="reset-submit-btn" disabled={loading} className="btn-gold w-full">
              {loading ? "Kaydediliyor..." : "Şifremi Güncelle"}
            </button>
          </form>
        )}
      </div>
      <p className="text-center text-xs text-slate-600 mt-6">
        <Link to="/giris" className="hover:text-[#D4AF37]">← Giriş sayfasına dön</Link>
      </p>
    </div>
  );
}
